import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=af067968"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports